import { ReactNode } from "react";
import "./ButtonTabs.css";

export function ButtonTabs<TTabValue>(props: {
  tabs: {
    content: ReactNode;
    value: TTabValue;
    disabled?: boolean;
  }[];
  selected: TTabValue;
  setSelected: (value: TTabValue) => void;
  disabled?: boolean;
}) {
  const { tabs, selected, setSelected, disabled } = props;
  return (
    <div className="button-squish-zone">
      {tabs.map(({ content, value, disabled: tabDisabled }, i) => (
        <div key={i}>
          <button
            className={`button-tab ${
              value === selected ? "button-tab-selected" : ""
            }`}
            disabled={(tabDisabled ?? false) || (disabled ?? false)}
            onClick={() => setSelected(value)}
          >
            {content}
          </button>
        </div>
      ))}
    </div>
  );
}
